const mapData = (() => {
	const storeData = {};
	let id = 1;

	return {
		set(element, key, data) {
			if (typeof element.ltaKey === 'undefined') {
				element.ltaKey = {
					id
				};
				id++;
			}

			storeData[element.ltaKey.id] = storeData[element.ltaKey.id] || {};
			storeData[element.ltaKey.id][key] = data;
		},
		get(element, key) {
			if (!element || typeof element.ltaKey === 'undefined') {
				return null;
			}

			const store = storeData[element.ltaKey.id];
			return (store && store[key]) || null;
		},
		delete(element, key) {
			if (typeof element.ltaKey === 'undefined') {
				return;
			}

			const store = storeData[element.ltaKey.id];
			if (store && key in store) {
				delete store[key];

				if (Object.keys(store).length > 0) {
					return;
				}

				delete storeData[element.ltaKey.id];
				delete element.ltaKey;
			}
		}
	};
})();

const Data = {
	setData(instance, key, data) {
		mapData.set(instance, key, data);
	},
	getData(instance, key) {
		return mapData.get(instance, key);
	},
	removeData(instance, key) {
		mapData.delete(instance, key);
	}
};

export default Data;
